import cc from 'classcat';
import { jsx } from 'react/jsx-runtime';
import { svgCls } from './styles/svg.js';

const HexagonShape = ({
  fillColor = "currentColor",
  shapeRef,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  strokeColor,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx("svg", {
    ...svgProps,
    className: cc([svgCls, svgProps.className]),
    ref: shapeRef,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 432.5 372",
    fill: fillColor,
    children: /*#__PURE__*/jsx("path", {
      d: "M324.4 372l108.1-186L324.4 0H108.1L0 186l108.1 186z"
    })
  });
};

export { HexagonShape };
//# sourceMappingURL=HexagonShape.js.map
